import React, { useState } from "react";

export default function TaxForm({
  initialData,
  onSave,
  onCancel,
}) {
  const [form, setForm] = useState(
    initialData || {
      tax_type: "GST",
      registration_no: "",
      state_code: "",
      is_active: true,
    }
  );

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: 16,
        marginBottom: 16,
        background: "#f9fafb",
      }}
    >
      <div className="erp-form-grid">
        <div className="erp-field">
          <label>Tax Type</label>
          <select
            value={form.tax_type}
            onChange={(e) =>
              setForm({
                ...form,
                tax_type: e.target.value,
              })
            }
          >
            <option value="GST">GST</option>
            <option value="PAN">PAN</option>
            <option value="CIN">CIN</option>
          </select>
        </div>

        <div className="erp-field">
          <label>Registration No</label>
          <input
            value={form.registration_no}
            onChange={(e) =>
              setForm({
                ...form,
                registration_no: e.target.value,
              })
            }
          />
        </div>

        <div className="erp-field">
          <label>State Code</label>
          <input
            value={form.state_code}
            onChange={(e) =>
              setForm({
                ...form,
                state_code: e.target.value,
              })
            }
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 24,
          }}
        >
          <input
            type="checkbox"
            checked={form.is_active}
            onChange={(e) =>
              setForm({
                ...form,
                is_active: e.target.checked,
              })
            }
          />
          Active
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
          marginTop: 16,
        }}
      >
        <button
          className="btn btn-secondary"
          onClick={onCancel}
        >
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={() => onSave(form)}
        >
          Save Tax
        </button>
      </div>
    </div>
  );
}
